function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
import React, { Fragment } from 'react';
import { renderToString } from 'react-dom/server';
import { FetchWrapper } from './fetch-wrapper';
import Loader from './loader';
var defaultSettings = {
  "ClientId": "0a1df890-bfdb-44ac-b3f0-96aab07afff1",
  "TenantName": "dgsidtest",
  "TenantDomain": "onmicrosoft.com",
  "RedirectUrl": "https://hcpportal.local.cas.dgs.com/~/oneIdlogin",
  "LoginUrl": "/~/oneIdlogin",
  "ApiBaseUrl": "https://dev.api.dgs.com/OneCustomer-Dev/v1",
  "CultureCode": "en",
  "CountryCode": "DK",
  "UserListSize": 30,
  "UseDataLocation": false //TODO REMOVE AFTER DATA LOCATION IS LIVE
};
var defaultUserStatus = {
  "StatusCompleted": "Completed",
  "StatusPending": "Pending",
  "StatusInvitationExpired": "Invitation Expired",
  "StatusInvitationFailed": "Invitation failed"
};
var defaultToolTip = {
  "EditUser": "Edit user",
  "RemoveUser": "Remove user",
  "SendInvite": "Send invitation"
};
function setUserStatusIcon(status) {
  return status.toLowerCase() == "completed" ? "icon-completed" : "icon-pending";
}
function setUserStatusBtn(status) {
  return status.toLowerCase() == "completed";
}
function setUserStatusClassName(status) {
  return "user-status-".concat(status.toLowerCase() == "completed" ? "completed" : "pending");
}
function titlesColumns(componentParentElem) {
  var $thItems = componentParentElem.querySelectorAll('.remotecare-admin-panel-userlist-table table thead tr th');
  $thItems = Array.from($thItems);
  var thItemsTexts = [];
  var _iterator = _createForOfIteratorHelper($thItems),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var $thItem = _step.value;
      var textThItem = $thItem.textContent.trim();
      thItemsTexts.push(textThItem);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return thItemsTexts;
}
function clearInputs(moduleElement) {
  var inputs = moduleElement.querySelectorAll('.remotecare-admin-panel-popup input');
  inputs.forEach(function (inpt) {
    inpt.value = '';
  });
}
function validateInput(input, type) {
  var emailRegEx = /^([;,]?\s?([a-zA-Z0-9_\-\.\+]+)@([a-zA-Z0-9_\-\.\+]+)\.([a-zA-Z]{2,5}){1,25})+$/;
  var textRegEx = new RegExp('^[a-zA-Z]{1}');
  var inptParent = input.parentElement;
  var isOk = false;
  switch (type) {
    case 'email':
      isOk = emailRegEx.test(input.value);
      break;
    case 'country':
      isOk = input.value !== "-1";
      break;
    default:
      isOk = textRegEx.test(input.value);
      break;
  }
  if (!isOk) {
    inptParent.classList.add('error');
  } else {
    inptParent.classList.remove('error');
  }
  return isOk;
}
function showMsg(data) {
  return /*#__PURE__*/React.createElement("p", {
    className: "remotecare-admin-panel-msg"
  }, data);
}
function disabledStateSearchBox($input, $btn, state) {
  $input.disabled = state;
  $btn.disabled = state;

  // Set focus on input after search
  if (!state) {
    $input.focus();
  }
}
function loaderRenderToString() {
  return renderToString(/*#__PURE__*/React.createElement(Loader, null));
}
function showLoaderInBtn($button, showLoader) {
  var btnText = $button.textContent;
  if (showLoader) {
    $button.style.paddingRight = '5rem';
    $button.innerHTML = "".concat(btnText).concat(loaderRenderToString());
  } else {
    $button.removeAttribute('style');
    $button.querySelector('.remotecare-admin-panel-loader').remove();
  }
}
var UsersList = /*#__PURE__*/function (_React$Component) {
  function UsersList(props) {
    var _this;
    _classCallCheck(this, UsersList);
    _this = _callSuper(this, UsersList, [props]);
    _this.state = {
      showModal: false,
      modalId: '',
      users: [],
      countries: [],
      tableColumnTitles: [],
      loading: true,
      loadMore: false,
      loadOnSearch: false
    };
    _this.searchParams = {
      page: 1,
      size: 30,
      search: ''
    };
    _this.moduleElement = document.querySelector('.remotecare-admin-panel');
    _this.$inputSearch = _this.moduleElement.querySelector('#remotecare-admin-panel-search-110101');
    _this.$btnSearch = _this.moduleElement.querySelector('#remotecare-admin-panel-search-110101 + button');
    _this.msg = {
      notFound: _this.moduleElement.dataset.msgNotfound
    };
    _this.actEmployee = null;
    _this.usersCount = 0;
    _this.settings = _this.getSettingsFromComponent(_this.moduleElement);
    _this.userStatusLabels = _this.getUserStatusLabelsFromComponent(_this.moduleElement);
    _this.tooltiplabels = _this.getToolTipsLabelsFromComponent(_this.moduleElement);
    _this.dropdownResetPasswordButton = document.querySelector('.remotecare-user-panel li[data-currentuser-email] a');
    if (_this.settings.UseDataLocation)
      //TODO REMOVE AFTER DATA LOCATION IS LIVE
      {
        _this.$selectCountryList = $('#popup-edit-country', _this.moduleElement);
      }
    _this.$editFirstName = $('#popup-edit-firstname', _this.moduleElement);
    _this.$editLastName = $('#popup-edit-lastname', _this.moduleElement);
    return _this;
  }
  _inherits(UsersList, _React$Component);
  return _createClass(UsersList, [{
    key: "init",
    value: function init() {
      this.settings.debug = false;
      if (this.settings.debug) console.log(this.settings);
      if (this.settings.UserListSize) this.searchParams.size = this.settings.UserListSize;
      FetchWrapper.init(this.settings);
      this.setPopups();
      this.setResetPasswordButton();
      this.getData();
    }
  }, {
    key: "getSettingsFromComponent",
    value: function getSettingsFromComponent(component) {
      var settingsElement = component.querySelector('script[data-hcpid="panel-settings"]');
      var settings = defaultSettings;
      try {
        settings = JSON.parse(settingsElement.textContent);
        var userEmailLi = document.querySelector('.remotecare-user-panel li[data-currentuser-email]');
        settings.CurrentUserEmail = userEmailLi ? userEmailLi.getAttribute('data-currentuser-email') : '';
      } catch (e) {
        settings.error = "".concat(e.name, " - ").concat(e.message);
      }
      return settings;
    }
  }, {
    key: "getUserStatusLabelsFromComponent",
    value: function getUserStatusLabelsFromComponent(component) {
      var statusElement = component.querySelector('script[data-hcpid="user-status-labels"]');
      var datalist = defaultUserStatus;
      try {
        datalist = JSON.parse(statusElement.textContent);
      } catch (e) {
        datalist.error = "".concat(e.name, " - ").concat(e.message);
      }
      return datalist;
    }
  }, {
    key: "getToolTipsLabelsFromComponent",
    value: function getToolTipsLabelsFromComponent(component) {
      var tooltipElement = component.querySelector('script[data-hcpid="tool-tip-labels"]');
      var datalist = defaultToolTip;
      try {
        datalist = JSON.parse(tooltipElement.textContent);
      } catch (e) {
        datalist.error = "".concat(e.name, " - ").concat(e.message);
      }
      return datalist;
    }
  }, {
    key: "setResetPasswordButton",
    value: function setResetPasswordButton() {
      var _this2 = this;
      this.dropdownResetPasswordButton.addEventListener("click", function (e) {
        e.preventDefault();
        _this2.showPopup('popup-user-password-reset');
      });
    }
  }, {
    key: "getData",
    value: function getData() {
      var _this3 = this;
      FetchWrapper.fetchData().then(function (data) {
        _this3.setState({
          users: data.items,
          tableColumnTitles: titlesColumns(_this3.moduleElement),
          loading: false
        });
        _this3.setSearchBox();
        _this3.setLoadMore();
        _this3.checkLoadMore(data.total);
      }).catch(function (error) {
        return _this3.getError(error);
      });
      //TODO REMOVE AFTER DATA LOCATION IS LIVE
      if (this.settings.UseDataLocation) {
        FetchWrapper.fetchCountries(this.settings.CountryCode).then(function (data) {
          if (_this3.settings.debug) console.log("get countries", _this3.settings.CountryCode);
          _this3.setState({
            countries: data
          });
          _this3.setCountries();
        }).catch(function (error) {
          return _this3.getError(error);
        });
      }
    }
  }, {
    key: "loadEmployees",
    value: function () {
      var _loadEmployees = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var data, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.setState({
                loading: true
              });
              _context.p = 1;
              _context.n = 2;
              return FetchWrapper.fetchEmployees(this.searchParams);
            case 2:
              data = _context.v;
              if (this.state.loadOnSearch) {
                disabledStateSearchBox(this.$inputSearch, this.$btnSearch, false);
              }
              this.setState({
                users: data.items,
                loading: false,
                loadOnSearch: false
              });
              this.checkLoadMore(data.total);
              _context.n = 4;
              break;
            case 3:
              _context.p = 3;
              _t = _context.v;
              return _context.a(2, this.getError(_t));
            case 4:
              return _context.a(2);
          }
        }, _callee, this, [[1, 3]]);
      }));
      function loadEmployees() {
        return _loadEmployees.apply(this, arguments);
      }
      return loadEmployees;
    }()
  }, {
    key: "getError",
    value: function getError(error) {
      if (this.settings.debug) console.log("error", error);
      switch (error) {
        case 'Auth_error':
          this.showPopup('popup-user-session-expired');
          break;
        case 'Server_error':
        default:
          this.showPopup('popup-server-problems');
          break;
      }
      return error;
    }
  }, {
    key: "setCountries",
    value: function setCountries() {
      var _this4 = this;
      if (this.settings.debug) console.log("add countries");
      this.$selectCountryList.find('option:not(:first)').remove();
      this.$selectCountryList.parent().addClass('select-container');
      $.each(this.state.countries, function (index, value) {
        _this4.$selectCountryList.append('<option value=' + value.code + '>' + value.name + '</option>');
      });
    }
  }, {
    key: "setCountrySelected",
    value: function setCountrySelected(countrycode) {
      if (this.settings.debug) console.log("set selected");
      if (countrycode != null && countrycode.length > 0) {
        this.$selectCountryList.val(countrycode);
      } else {
        this.$selectCountryList.val(this.settings.CountryCode);
      }
    }
  }, {
    key: "showMsgPopup",
    value: function showMsgPopup(message, $btnAccept) {
      showLoaderInBtn($btnAccept, false);
      this.showPopup('popup-messages');
      var $popupMessage = this.moduleElement.querySelector('.popup-messages');
      $popupMessage.querySelector('.popup-subtitle').innerHTML = message;
    }
  }, {
    key: "setPopups",
    value: function setPopups() {
      var _this5 = this;
      //get all popups 
      var popups = this.moduleElement.querySelectorAll('.remotecare-admin-panel-popup');
      popups.forEach(function (element) {
        var btnCancel = element.querySelector('.button-cancel');
        var btnAccept = element.querySelector('.button-accept');
        if (element.classList.contains('popup-user-edit')) {
          var dataMsgSuccess = _this5.moduleElement.querySelector('.popup-user-edit').dataset.msgSuccessEdit;
          var fname = _this5.$editFirstName[0];
          var lname = _this5.$editLastName[0];
          var countrycode = null;
          if (_this5.settings.UseDataLocation)
            //TODO REMOVE AFTER DATA LOCATION IS LIVE
            {
              countrycode = _this5.$selectCountryList[0];
            }
          btnAccept.addEventListener('click', function (e) {
            e.target.disabled = true;
            var validateResult = false;
            if (_this5.settings.UseDataLocation)
              //TODO REMOVE AFTER DATA LOCATION IS LIVE
              {
                validateResult = validateInput(fname) && validateInput(lname) && validateInput(countrycode);
              } else {
              validateResult = validateInput(fname) && validateInput(lname);
            }
            if (validateResult) {
              var countryCodeValue = countrycode != null ? countrycode.value : null;
              showLoaderInBtn(e.target, true);
              FetchWrapper.editEmployee(_this5.actEmployee.personId, fname.value, lname.value, countryCodeValue).then(function () {
                _this5.loadEmployees().then(function () {
                  e.target.disabled = false;
                  _this5.hidePopup();
                  _this5.showMsgPopup(dataMsgSuccess, e.target);
                });
              }).catch(function (error) {
                e.target.disabled = false;
                showLoaderInBtn(e.target, false);
                _this5.hidePopup();
                _this5.getError(error);
              });
            } else {
              e.target.disabled = false;
            }
          });
          btnCancel.addEventListener('click', function (e) {
            _this5.hidePopup();
          });
        }
        if (element.classList.contains('popup-user-password-reset')) {
          var _dataMsgSuccess = _this5.moduleElement.querySelector('.popup-user-password-reset').dataset.msgSuccessReset;
          btnAccept.addEventListener('click', function (e) {
            showLoaderInBtn(e.target, true);
            e.target.disabled = true;
            FetchWrapper.resetPassword(_this5.settings.CurrentUserEmail, true).then(function () {
              e.target.disabled = false;
              _this5.hidePopup();
              _this5.showMsgPopup(_dataMsgSuccess, e.target);
            }).catch(function (error) {
              showLoaderInBtn(e.target, false);
              e.target.disabled = false;
              _this5.hidePopup();
              _this5.getError(error);
            });
          });
          btnCancel.addEventListener('click', function (e) {
            _this5.hidePopup();
          });
        }
        if (element.classList.contains('popup-user-invitation')) {
          var _dataMsgSuccess2 = _this5.moduleElement.querySelector('.popup-user-invitation').dataset.msgSuccessInvitation;
          btnAccept.addEventListener('click', function (e) {
            e.target.disabled = true;
            var email = document.getElementById('popup-invitation-email');
            var msgTxtDefault = document.getElementById('popup-invitation-defaulttext');
            var msgTxtPersonal = document.getElementById('popup-invitation-personaltext');
            if (validateInput(email, 'email')) {
              showLoaderInBtn(e.target, true);
              var separators = [';', ','];
              var emailArr = email.value.split(new RegExp(separators.join('|'), 'g'));
              var emails = emailArr.map(function (email) {
                return email.trim();
              });
              FetchWrapper.sendInv(emails, msgTxtDefault.innerHTML, msgTxtPersonal.innerHTML).then(function () {
                _this5.loadEmployees().then(function () {
                  e.target.disabled = false;
                  _this5.hidePopup();
                  _this5.showMsgPopup(_dataMsgSuccess2, e.target);
                });
              }).catch(function (error) {
                showLoaderInBtn(e.target, false);
                e.target.disabled = false;
                _this5.hidePopup();
                _this5.getError(error);
              });
            } else {
              e.target.disabled = false;
            }
          });
          btnCancel.addEventListener('click', function (e) {
            _this5.hidePopup();
          });
        }
        if (element.classList.contains('popup-user-remove')) {
          var _dataMsgSuccess3 = _this5.moduleElement.querySelector('.popup-user-remove').dataset.msgSuccessRemove;
          btnAccept.addEventListener('click', function (e) {
            showLoaderInBtn(e.target, true);
            e.target.disabled = true;
            _this5.searchParams.page = 1;
            FetchWrapper.removeEmployee(_this5.actEmployee.id, _this5.actEmployee.invitationId).then(function () {
              _this5.loadEmployees().then(function () {
                e.target.disabled = false;
                _this5.hidePopup();
                _this5.showMsgPopup(_dataMsgSuccess3, e.target);
              });
            }).catch(function (error) {
              showLoaderInBtn(e.target, false);
              e.target.disabled = false;
              _this5.hidePopup();
              _this5.getError(error);
            });
          });
          btnCancel.addEventListener('click', function (e) {
            _this5.hidePopup();
          });
        }
        if (element.classList.contains('popup-server-problems')) {
          btnAccept.addEventListener('click', function () {
            _this5.hidePopup();
          });
        }
        if (element.classList.contains('popup-user-session-expired')) {
          btnAccept.addEventListener('click', function () {
            window.location.href = _this5.settings.LoginUrl;
          });
        }
        if (element.classList.contains('popup-messages')) {
          btnAccept.addEventListener('click', function () {
            _this5.hidePopup();
          });
        }
      });

      // add new user popup
      var addNewUser = this.moduleElement.querySelectorAll('.remotecare-admin-panel-add-user');
      addNewUser.forEach(function (btn) {
        btn.addEventListener('click', function () {
          _this5.showPopup('popup-user-invitation');
        });
      });
    }
  }, {
    key: "setSearchBox",
    value: function setSearchBox() {
      var _this6 = this;
      if (this.settings.debug) console.log('search setup');
      this.$btnSearch.addEventListener('click', function () {
        submitInput();
      });
      this.$inputSearch.addEventListener('keypress', function (e) {
        if (e.keyCode == 13) {
          submitInput();
        }
      });
      var submitInput = function submitInput() {
        var inputVal = _this6.$inputSearch.value;
        _this6.setState({
          loadOnSearch: true
        });
        disabledStateSearchBox(_this6.$inputSearch, _this6.$btnSearch, true);
        _this6.checkLoadMore(0);
        _this6.searchParams.page = 1;
        _this6.searchParams.search = inputVal;
        _this6.loadEmployees();
      };
    }
  }, {
    key: "setLoadMore",
    value: function setLoadMore() {
      var _this7 = this;
      this.moreBtn = this.moduleElement.querySelector('.remotecare-admin-panel-more-btn');
      this.moreBtn.addEventListener('click', function (e) {
        _this7.searchParams.page++;
        _this7.moreBtn.disabled = true;
        _this7.setState({
          loading: true,
          loadMore: true
        });
        FetchWrapper.fetchEmployees(_this7.searchParams).then(function (data) {
          var newData = [].concat(_toConsumableArray(_this7.state.users), _toConsumableArray(data.items));
          _this7.setState({
            users: newData,
            loading: false,
            loadMore: false
          });
          _this7.moreBtn.disabled = false;
          _this7.checkLoadMore(data.total);
        }).catch(function (error) {
          _this7.getError(error);
          _this7.moreBtn.disabled = false;
        });
      });
    }
  }, {
    key: "checkLoadMore",
    value: function checkLoadMore(total) {
      if (this.state.users.length < total) {
        this.moreBtn.style.display = 'inline-block';
      } else {
        this.moreBtn.style.display = 'none';
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.init();
    }
  }, {
    key: "loadPopup",
    value: function loadPopup(event) {
      var trg = $(event.target);
      var popupId = trg.closest('[data-popup-id]').attr('data-popup-id');
      var rowIndex = trg.closest('[data-user-index]').attr('data-user-index');
      this.actEmployee = this.state.users[rowIndex];
      this.showPopup(popupId);
    }
  }, {
    key: "showPopup",
    value: function showPopup(popupId) {
      var actPopup;
      actPopup = this.moduleElement.querySelector('.remotecare-admin-panel-popup.show-me');
      if (actPopup) actPopup.classList.remove('show-me');
      actPopup = this.moduleElement.querySelector('.' + popupId);
      actPopup.classList.add('show-me');
      var userName = actPopup.querySelector('[data-user-name]');
      if (userName) {
        var fnameTxt = this.actEmployee.firstName ? this.actEmployee.firstName : '';
        var lnameTxt = this.actEmployee.lastName ? this.actEmployee.lastName : '';
        actPopup.querySelector('[data-user-name]').innerHTML = fnameTxt + " " + lnameTxt;
        if (this.settings.debug) console.log("set data for edit");
        // set data to inputs
        this.$editFirstName.val(this.actEmployee.firstName);
        this.$editLastName.val(this.actEmployee.lastName);
        //TODO REMOVE AFTER DATA LOCATION IS LIVE       
        if (this.settings.UseDataLocation) {
          this.setCountrySelected(this.actEmployee.countryCode);
        }
      }
      var email = document.getElementById('popup-invitation-email');
      if (email && this.actEmployee) {
        email.value = this.actEmployee.email;
      }
    }
  }, {
    key: "hidePopup",
    value: function hidePopup() {
      this.moduleElement.querySelector('.remotecare-admin-panel-popup.show-me').classList.remove('show-me');
      this.actEmployee = null;
      clearInputs(this.moduleElement);
      var errorInpts = this.moduleElement.querySelectorAll('.input-container.error');
      errorInpts.forEach(function (inpt) {
        inpt.classList.remove('error');
      });
    }
  }, {
    key: "setUserStatusLabel",
    value: function setUserStatusLabel(status) {
      switch (status) {
        case 'Completed':
          return this.userStatusLabels.StatusCompleted;
        case 'Pending':
          return this.userStatusLabels.StatusPending;
        case 'InvitationExpired':
          return this.userStatusLabels.StatusInvitationExpired;
        case 'InvitationFailed':
          return this.userStatusLabels.StatusInvitationFailed;
        default:
          return '';
      }
    }
  }, {
    key: "RendererUsers",
    value: function RendererUsers() {
      var _this8 = this;
      var cellActionsStyles = {
        width: "auto",
        minWidth: "120px"
      };
      var users = this.state.users;
      return users.map(function (userItem, index) {
        return /*#__PURE__*/React.createElement("tr", {
          key: index,
          className: "remotecare-admin-panel-user-element",
          "data-user-id": userItem.id,
          "data-user-index": index,
          "data-user-invitationid": userItem.invitationId,
          "data-person-id": userItem.personId
        }, /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.state.tableColumnTitles[0]
        }, /*#__PURE__*/React.createElement("span", null, userItem.firstName)), /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.state.tableColumnTitles[1]
        }, /*#__PURE__*/React.createElement("span", null, userItem.lastName)), _this8.settings.UseDataLocation ? /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.state.tableColumnTitles[2]
        }, /*#__PURE__*/React.createElement("span", null, userItem.countryName)) : null, /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.settings.UseDataLocation ? _this8.state.tableColumnTitles[3] : _this8.state.tableColumnTitles[2]
        }, /*#__PURE__*/React.createElement("span", null, userItem.email)), /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.settings.UseDataLocation ? _this8.state.tableColumnTitles[4] : _this8.state.tableColumnTitles[3],
          "data-user-status": userItem.status
        }, /*#__PURE__*/React.createElement("span", {
          className: setUserStatusIcon(userItem.status)
        }), /*#__PURE__*/React.createElement("span", {
          className: setUserStatusClassName(userItem.status)
        }, _this8.setUserStatusLabel(userItem.status))), /*#__PURE__*/React.createElement("td", {
          "data-th": _this8.settings.UseDataLocation ? _this8.state.tableColumnTitles[5] : _this8.state.tableColumnTitles[4],
          style: cellActionsStyles
        }, /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
          type: "button",
          "data-popup-id": "popup-user-edit",
          onClick: function onClick(e) {
            return _this8.loadPopup(e);
          },
          disabled: !setUserStatusBtn(userItem.status)
        }, /*#__PURE__*/React.createElement("span", {
          className: "visuallyhidden tooltip"
        }, _this8.tooltiplabels.EditUser, "  "), /*#__PURE__*/React.createElement("span", {
          className: "icon-edit"
        }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
          type: "button",
          "data-popup-id": "popup-user-invitation",
          onClick: function onClick(e) {
            return _this8.loadPopup(e);
          },
          disabled: setUserStatusBtn(userItem.status)
        }, /*#__PURE__*/React.createElement("span", {
          className: "visuallyhidden tooltip"
        }, _this8.tooltiplabels.SendInvite, " "), /*#__PURE__*/React.createElement("span", {
          className: "icon-send-invite"
        }))), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("button", {
          type: "button",
          "data-popup-id": "popup-user-remove",
          onClick: function onClick(e) {
            return _this8.loadPopup(e);
          },
          disabled: userItem.isAdmin
        }, /*#__PURE__*/React.createElement("span", {
          className: "visuallyhidden tooltip"
        }, _this8.tooltiplabels.RemoveUser, " "), /*#__PURE__*/React.createElement("span", {
          className: "icon-remove"
        }))))));
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
        users = _this$state.users,
        loading = _this$state.loading,
        loadMore = _this$state.loadMore,
        loadOnSearch = _this$state.loadOnSearch;
      return /*#__PURE__*/React.createElement(Fragment, null, !loadMore ?
      // first load or after search
      users.length > 0 ?
      // Display loader on search || user list
      loadOnSearch ? /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: "5"
      }, /*#__PURE__*/React.createElement(Loader, null))) : this.RendererUsers() :
      /*#__PURE__*/
      // Display loader || message not found
      React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
        colSpan: "5"
      }, loading ? /*#__PURE__*/React.createElement(Loader, null) : showMsg(this.msg.notFound))) : [
      // Display user list and loader when try load more
      this.RendererUsers(), loading && /*#__PURE__*/React.createElement("tr", {
        key: users.length + 1
      }, /*#__PURE__*/React.createElement("td", {
        colSpan: "5"
      }, /*#__PURE__*/React.createElement(Loader, null)))]);
    }
  }]);
}(React.Component);
export default UsersList;